var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('section',{staticClass:"modal"},[_c('section',{staticClass:"modal__content"},[_c('Header'),_c(_vm.componentName,{tag:"component",on:{"changeComponent":_vm.changeComponent}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }